import { Table, ActionIcon, Menu } from '@mantine/core';
import { modals } from '@mantine/modals';
import { IconDotsVertical, IconEdit, IconTrash } from '@tabler/icons-react';

import { CustomTable, CustomTableMobile, useResponsive } from '@/shared';
import { useUpdateWhitelist } from '../hooks/use-update-whitelist';
import { useDeleteWhitelist } from '../hooks/use-delete-whitelist';
import { EditWhitelistForm } from './edit-whitelist-form';

import type { TWhitelist } from '../store/types';

type Props = {
  items: TWhitelist[];
  isLoading?: boolean;
};

export const WhitelistTable = (props: Props) => {
  const { items } = props;
  const { isDesktop } = useResponsive();

  const { handleWhitelistEdit } = useUpdateWhitelist();
  const { openDeleteModal } = useDeleteWhitelist();

  const openEditModal = (item: TWhitelist) => modals.open({
    title: `Редактирование ID ${item.id}`,
    centered: true,
    children: (
      <EditWhitelistForm
        whitelistItem={item}
        onSubmit={handleWhitelistEdit}
        onClose={modals.closeAll}
      />
    ),
  });

  const getActions = (item: TWhitelist) => (
    <Menu position="bottom-end" shadow="md" width={200}>
      <Menu.Target>
        <ActionIcon variant="subtle">
          <IconDotsVertical size={16} />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item
          leftSection={<IconEdit size={14} />}
          onClick={() => openEditModal(item)}
        >
          Редактировать
        </Menu.Item>
        <Menu.Divider />
        <Menu.Item
          color="red"
          leftSection={<IconTrash size={14} />}
          onClick={() => openDeleteModal(item)}
        >
          Удалить
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );

  const titles = [
    'ID',
    'ip',
    'Описание',
  ];

  const rows = items.map((item) => (
    <Table.Tr key={item.id}>
      <Table.Td>{item.id}</Table.Td>
      <Table.Td>{item.ip}</Table.Td>
      <Table.Td>{item.note}</Table.Td>
      <Table.Td width={50}>{getActions(item)}</Table.Td>
    </Table.Tr>
  ));

  const rowsMobile = items.map((item) => ({
    key: item.id,
    headerActions: getActions(item),
    items: [
      { name: titles[1], value: item.ip },
      { name: titles[2], value: item.note },
      { name: titles[0], value: item.id },
    ],
  }));

  return isDesktop
    ? (
      <CustomTable
        {...props}
        titles={titles}
        rows={rows}
        isPaginated={false}
      />
    )
    : (
      <CustomTableMobile
        rows={rowsMobile}
        headerPointsCount={2}
        isPaginated={false}
        {...props}
      />
    );
};
